import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const VendorCard = ({ vendor, onEdit, onView, onContact }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-success/10 text-success border-success/20';
      case 'inactive':
        return 'bg-muted text-muted-foreground border-border';
      case 'blocked':
        return 'bg-error/10 text-error border-error/20';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevated transition-shadow duration-200">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Building2" size={24} className="text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">{vendor?.name}</h3>
            <p className="text-sm text-muted-foreground">{vendor?.email}</p>
          </div>
        </div>
        <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getStatusColor(vendor?.status)}`}>
          {vendor?.status}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <p className="text-xs text-muted-foreground">Outstanding Balance</p>
          <p className="font-semibold text-foreground">${vendor?.outstandingBalance?.toLocaleString()}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Total Transactions</p>
          <p className="font-semibold text-foreground">{vendor?.totalTransactions}</p>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Icon name="Phone" size={14} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground">{vendor?.phone}</span>
        </div>
        <div className="flex items-center space-x-2">
          <Button variant="ghost" size="sm" onClick={() => onContact(vendor)}>
            <Icon name="Mail" size={16} />
          </Button>
          <Button variant="ghost" size="sm" onClick={() => onEdit(vendor)}>
            <Icon name="Edit" size={16} />
          </Button>
          <Button variant="outline" size="sm" onClick={() => onView(vendor)}>
            View
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VendorCard;